import { GeneralCatalogItem } from 'data-layer-cr/dist/models';
import { useNetworkObserver } from 'data-layer-cr/dist/network';
import { DisplayItem } from 'design-system';
import { useMemo } from 'react';
import { mapCatatalogToDisplay } from 'src/functions/mapCatatalogToDisplay';
import { ECONOMIC_ACTIVITIES_REQUEST } from 'src/store/legalEntityCatalog/actions/legalEntityRequestIdentifiers';

type Props = {
  economicActivities: GeneralCatalogItem[];
};

type HookResult = {
  requestingEconomicActivities: boolean;
  economicActivitiesOptions: DisplayItem[];
};

export default function useEconomicActivityInformation({
  economicActivities,
}: Props): HookResult {
  const economicActivitiesRequestStatus = useNetworkObserver(
    ECONOMIC_ACTIVITIES_REQUEST,
  );

  const economicActivitiesOptions = useMemo(
    () => mapCatatalogToDisplay(economicActivities ?? []),
    [economicActivities],
  );

  return {
    requestingEconomicActivities:
      economicActivitiesRequestStatus === 'requesting',
    economicActivitiesOptions,
  };
}
